var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon3Blue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5868_24868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4277 2.6709H1.5918C0.721258 2.6709 0.00976562 3.37926 0.00976562 4.25293V13.7451C0.00976562 14.6191 0.721715 15.3271 1.5918 15.3271H16.4277C17.2983 15.3271 18.0098 14.6188 18.0098 13.7451V4.25293C18.0098 3.37905 17.2979 2.6709 16.4277 2.6709ZM16.1848 3.72559C15.6733 4.23876 9.66525 10.2664 9.41842 10.514C9.21227 10.7208 8.80737 10.721 8.60111 10.514L1.83473 3.72559H16.1848ZM1.06445 13.5512V4.44682L5.60189 8.99902L1.06445 13.5512ZM1.83473 14.2725L6.34647 9.74602L7.85414 11.2586C8.47198 11.8785 9.5478 11.8782 10.1654 11.2586L11.6731 9.74606L16.1848 14.2725H1.83473ZM16.9551 13.5512L12.4176 8.99902L16.9551 4.44682V13.5512Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5868_24868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon3Blue);
export default __webpack_public_path__ + "static/media/email_icon3_blue.24a403033df6110b7f88adfdb0aa34f8.svg";
export { ForwardRef as ReactComponent };